// Better Auth error codes → German; anything else falls back to the step's generic message
const MESSAGES: Record<string, string> = {
  INVALID_EMAIL_OR_PASSWORD: "E-Mail oder Passwort ist falsch.",
  INVALID_EMAIL: "Gib eine gültige E-Mail-Adresse ein.",
  USER_ALREADY_EXISTS:
    "Zu dieser E-Mail-Adresse gibt es schon ein Konto. Melde dich an, z. B. mit Google, falls du dich so registriert hast.",
  USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL:
    "Zu dieser E-Mail-Adresse gibt es schon ein Konto. Melde dich an, z. B. mit Google, falls du dich so registriert hast.",
  PASSWORD_TOO_SHORT: "Das Passwort muss mindestens 8 Zeichen lang sein.",
  PASSWORD_TOO_LONG: "Das Passwort ist zu lang.",
  // thrown by the allowlist in lib/auth.ts
  FORBIDDEN: "Diese E-Mail-Adresse ist nicht freigeschaltet.",
}

const RATE_LIMITED =
  "Zu viele Versuche. Warte eine Minute und versuch es dann noch einmal."

export const authErrorMessage = (
  error: { status: number; code?: string },
  fallback: string
) => {
  if (error.code && MESSAGES[error.code]) return MESSAGES[error.code]
  if (error.status === 403) return MESSAGES.FORBIDDEN
  return error.status === 429 ? RATE_LIMITED : fallback
}
